export default {
    "meta": {
        "title": "Custom Algorithms on BingX",
        "description": "Discover how you can deploy custom trading scripts on BingX for ultimate control and testing of your automated strategies."
    },
    "hero": {
        "notification": "Take control of your trading strategies.",
        "h1": "Custom Algorithms on BingX",
        "paragraph1": "Implementing custom trading algorithms on BingX gives traders unparalleled flexibility to execute and refine their strategies. With support for automation, the possibilities are nearly endless.",
        "paragraph2": "Custom algorithms on BingX offer a robust way to test ideas in a live trading environment. But to do so, using their API can be daunting. Gunbot allows traders to build, deploy, and optimize trading scripts with complete control over execution parameters, data integration, and custom indicators.",
        "chartSymbol": "BTC/USD",
        "chartFeatures": [
            {
                "id": 1,
                "title": "Real-time Order Visualization",
                "description": "Visualize trades as they execute, helping you refine algorithm performance instantly."
            },
            {
                "id": 2,
                "title": "Multi-Timeframe Insights",
                "description": "Monitor key market data across various timeframes to ensure your custom algorithms respond effectively to trends."
            }
        ],
        "reviewHeading": "Why Traders Choose Gunbot"
    },
    "block1": {
        "heading": "Enhanced Customization for BingX Trading",
        "paragraph": "Deploying trading scripts on BingX provides a straightforward path to implement automation. However, this setup is often constrained by the limitations of exchange-provided tools. With Gunbot, you gain an additional layer of customization and control. From integrating dynamic market data to leveraging JavaScript for strategy creation, Gunbot empowers traders to go beyond basic trading scripts and achieve truly flexible automation with solid charting.",
        "imgAlt": "A dashboard showcasing advanced trading metrics and strategy configurations",
        "featureTitle1": "Full Market Data Access",
        "featureDescription1": "Utilize Gunbot's integration to access comprehensive market data, enabling richer algorithm inputs.",
        "featureTitle2": "Dynamic Strategy Adjustments",
        "featureDescription2": "Update and optimize your strategies in real-time using Gunbot's powerful AutoConfig feature.",
        "featureTitle3": "Comprehensive Testing Tools",
        "featureDescription3": "Test your scripts thoroughly with integrated backtesting options before deployment.",
        "featureTitle4": "Seamless BingX Compatibility",
        "featureDescription4": "Gunbot offers seamless connectivity with BingX, enabling smooth deployment of custom algorithms."
    },
    "quote": {
        "paragraph": "Gunbot is not just a tool; it's a platform that allows you to redefine what's possible in automated trading."
    },
    "resources": {
        "heading": "Explore More",
        "subheading": "Dive deeper into features that make Gunbot an excellent choice for custom trading algorithms.",
        "description": "Here are some resources to help you understand how Gunbot can enhance your trading strategies on BingX.",
        "resources": [
            {
                "title": "Supported Exchanges",
                "description": "Check out all the exchanges that Gunbot integrates with, including BingX.",
                "link": "https://www.gunbot.com/exchanges/",
                "linkText": "View Exchanges"
            },
            {
                "title": "Example Strategies",
                "description": "Explore examples of JavaScript-based custom strategies for Gunbot.",
                "link": "https://www.gunbot.com/support/docs/custom-strategies/example-strategies/overview/",
                "linkText": "See Examples"
            },
            {
                "title": "BingX Trading Bot",
                "description": "Learn about automating your trades on BingX with Gunbot.",
                "link": "https://www.gunbot.com/exchanges/bingx-trading-bot/",
                "linkText": "BingX Trading Bot"
            },
            {
                "title": "Custom Strategy Functionalities",
                "description": "Understand how Gunbot empowers you to create custom trading strategies.",
                "link": "https://www.gunbot.com/support/docs/custom-strategies/what-are-custom-strategies/",
                "linkText": "Learn More"
            }
        ]
    },
    "block2": {
        "heading": "Custom Algorithms Beyond BingX",
        "paragraph": "While BingX provides a reliable foundation for deploying custom trading algorithms, integrating a tool like Gunbot significantly extends your capabilities. With Gunbot, you have full freedom to define custom logic, dynamically adjust strategies based on market conditions, and leverage advanced tools like AutoConfig for precise pair management. Whether you're building from scratch or optimizing existing scripts, Gunbot ensures your algorithms remain robust and adaptable.",
        "imgAlt": "A trading chart illustrating dynamic strategy adjustments"
    },
    "cta": {
        "text": "Curious how Gunbot can enhance your BingX experience?",
        "linkText": "Contact us now",
        "link": "https://www.gunbot.com/contact/",
        "linkTitle": "Get in Touch"
    },
    "pricing": {
        "heading": "Flexible Plans for Every Trader",
        "primaryButtonText": "I want this!",
        "yearlyAdmonition": "-50%",
        "lifetimeAdmonition": "Best value",
        "tabs": {
            "Monthly": [],
            "Annual": [],
            "Lifetime": []
        },
        
        
        "joinGunbotCommunity": "Join Gunbot community",
        "moreDetailsAbout": "More details about"
    }
}
